module.exports = __webpack_public_path__ + "static/fresenius-logo-8daecb822b5ba710bd07036ea2afe1bb.jpeg";